export default "__VITE_ASSET__a331a031__"